import React, { useEffect, useState } from "react";
import { Form, Input, Modal } from "antd";
import { Close } from "@mui/icons-material";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";
import { deleteCompany } from "../../../../../../store/actions/company";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

const DeleteCompanyModal = ({
  preview,
  previewHandler,
  selectedCompany,
  navigateToListing,
}) => {
  const [deleteLoader, setdeleteLoader] = useState(false);
  const [form] = Form.useForm();
  const { http } = global.services;
  const dispatch = useDispatch();
  const history = useHistory();

  const deleteHandler = () => {
    setdeleteLoader(true);
    http
      .delete(`user-company`, {
        id: selectedCompany.id,
      })
      .finally(() => setdeleteLoader(false))
      .then(() => {
        toast.success("Company deleted successfully");
        dispatch(deleteCompany(selectedCompany.id));
        previewHandler();
        if (navigateToListing) history.push("/companies");
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error ?? "Something went wrong");
      });
  };

  useEffect(() => {
    if (preview) form.resetFields();
  }, [preview]);

  return (
    <Modal
      visible={preview}
      centered
      width={600}
      className="delete-company-modal"
      footer={null}
      onCancel={previewHandler}
      closable={false}
    >
      <button className="close-btn" onClick={previewHandler}>
        <Close />
      </button>
      <h2>Confirm Company Deletion</h2>
      <p>
        Are you sure you want to delete this company? This action will permanently remove
        the company and all associated data. It cannot be undone.
      </p>
      <Form form={form} className="customize-form" onFinish={deleteHandler}>
        <label htmlFor="confirm-field">Please type DELETE to confirm</label>
        <Form.Item
          name="delete"
          rules={[
            {
              required: true,
              message: "Please type DELETE to confirm",
            },
            {
              validator: (_, value) => {
                if (!value) return Promise.reject();
                if (value !== "DELETE") {
                  return Promise.reject("Please type DELETE to confirm");
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input id="confirm-field" type="text" placeholder="DELETE" />
        </Form.Item>
        <div className="action-box">
          <button type="button" onClick={previewHandler}>
            Cancel
          </button>
          <button className="delete">
            {deleteLoader ? <BeatLoader size={8} color="#fff" /> : "Delete"}
          </button>
        </div>
      </Form>
    </Modal>
  );
};

export default DeleteCompanyModal;
